var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.helpID === 'Open')?_c('Open'):_vm._e(),(_vm.helpID === 'Pan')?_c('Pan'):_vm._e(),(_vm.helpID === 'Zoom')?_c('Zoom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }